import { render, staticRenderFns } from "./TerceiroDePara.vue?vue&type=template&id=4cf98f5e&"
import script from "./TerceiroDePara.vue?vue&type=script&lang=js&"
export * from "./TerceiroDePara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports